
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import Uploader from './uploader'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
components: {
XButton,
Group,
Cell,
PopupRadio,
XInput,
Loading,
Datetime,
XTextarea,
Confirm,
Flexbox,
OnboardHeader,
Uploader,
FlexboxItem
},
data () {
return {
uploadIndex: 0,
workList: [],
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
deleteRowsConfirm: false,
deleteCurIndex: '',
showLoading: true,
no_certificate: 1,
code: '',
hiring_type: '',
mobileFlag: false,
workTypeItems: [
{ key: 1, value: this.$tsg('实习工作') },
{ key: 2, value: this.$tsg('全职正式工作') }
],
styleItems: []
}
},
computed: {






},
created () {
this.id = this.$route.query.id

this.mobileFlag = this.isMobile()
this.postPsOption()

var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)


PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.data = data
this.hiring_type = data.hiring_type
this.showLoading = false
}
},

err => {
if (err === 2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
return false
}
)


PreEntryApi.getStatusValue({ id: this.id, code: this.code }, (data, meta) => {
if (data) {
this.no_certificate = data.no_certificate
}
})

PreEntryApi.getExperience(
{ id: this.id, getField: 'certificate_file', code: this.code },
(data, meta) => {
if (data) {
this.workList = data
this.workList.forEach(











)
} else {
this.addWork()
}
this.showLoading = false
},
(code, message) => {
if (code === -1) {
this.addWork()
}
this.showLoading = false
},
err => {
this.showLoading = false
},
err => {
this.showLoading = false
}
)
},
methods: {
returnFileData (res, field) {
this.workList[this.uploadIndex].file = res.src
this.workList[this.uploadIndex].file_id = res.id
this.workList[this.uploadIndex].file_url = res.url
},
uploadCard (field, key) {
this.uploadIndex = key
this.$refs[field][key].UploadFileType()
},
clear (type, key, val) {
if (val) {
this[type][key][val] = ''
} else {
this[type] = ''
}
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.workList.splice(this.deleteCurIndex, 1)

thindMaterial(3)
},
changeWorkStatus () {
this.no_certificate = this.no_certificate === 1 ? 2 : 1
if (this.no_certificate === 2) {
this.workList = []
PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
certificate_file: this.workList,
saveField: 'certificate_file'
},
(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}
},
(code, message) => {
this.$message.error(this.$tsg('资料信息更新失败。'))
}
)
if (this.workList.length === 0) {
this.addWork()
}
} else {
if (this.workList.length === 0) {
this.addWork()
}
}

PreEntryApi.updateStatusValue(
{
id: this.id,
field: 'no_certificate',
no_certificate: this.no_certificate,
code: this.code
},
(data, meta) => {},
err => {
this.$message.error(this.$tsg('状态字段更新失败。'))
}
)
},
removeWork () {
this.workList.pop()
},
addWork () {





/*
var newEntryDate = '',newQuitDate = '';
if(this.workList.length > 0) {
var quitDate = this.workList[this.workList.length - 1].quit_date;
if(quitDate) {
newEntryDate = quitDate;
newQuitDate  = quitDate;
}
}
*/

this.workList.push({
entry_date: '',
certificate_style: '',
valid_date: '',
certificate_name: '',
mechanism: '',
file: '',
file_url: '',
file_id: 1
})
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
sendMaterial (returnFlag) {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}


var listLength = this.workList.length,
workList = []
for (var i = 0; i < listLength; i++) {
if (this.no_certificate !== 2) {
if (!this.workList[i]['entry_date'] || !this.workList[i]['certificate_style'] || !this.workList[i]['certificate_name'] || !this.workList[i]['file_url']) {
this.$message.error(this.$tsg('必填项不能位空'))
return false
}
}
if (
this.workList[i]['entry_date'] ||
this.workList[i]['valid_date'] ||
this.workList[i]['certificate_name'] ||
this.workList[i]['certificate_code'] ||
this.workList[i]['file_url'] ||
this.workList[i]['mechanism']
) {
workList.push(this.workList[i])
}
}

if (this.no_certificate === 2) {
this.workList = []
}

PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
certificate_file: workList,
saveField: 'certificate_file'
},
(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}

if (returnFlag === 2) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}
},
(code, message) => {
this.$message.error(this.$tsg('资料信息更新失败。'))
}
)
},
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {
const typeObj = data['11'] || {}
this.styleItems = Object.keys(typeObj).map(key => ({
key: key,
value: typeObj[key]
}))

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/certificate.vue